import React from 'react'
import { connect } from 'react-redux'
import { editSets } from "../../actions/settings"
import Select from 'react-select'
import { sortOpts } from '../../utils/utils'
import DeleteConfirmation from '../ui/DeleteConfirmation'
import SettingsItemForm from './SettingsItemForm'

class SetsUsrgItem extends SettingsItemForm {

  modelName = 'usrg'

  render() {
    const { data, user_s } = this.props;
    const { data: nData, errors } = this.state;
    const orgs = {
      ...this.props.orgs,
      0: {
        org_id: 0,
        org_desc: '-',
        org_active: 1
      }
    };

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deleteItem}
        onCancel={this.toggleDelConf}
      />
      :
      '';

    var orgsOpt = [];
    for (var key in orgs){
      if(orgs.hasOwnProperty(key) && (orgs[key].org_active === 1
        || orgs[key].org_id === nData.usrg_org_id)) {
        orgsOpt.push({value:orgs[key].org_id,label:orgs[key].org_desc});
      }
    }
    orgsOpt.sort(sortOpts);

    if(this.state.editing){
      return(
        <tr>
          <td>
          {delConf}
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.usrg_desc}
                name="usrg_desc"
                onChange={this.updateInput}
                placeholder="Название"
                autoFocus
              />
            </div>
            <div className="form-inline">
              <button  type="button" className="btn btn-success"
                onClick={this.saveItem} title="Сохранить">
                <span className="glyphicon glyphicon-save"></span>
              </button>{" "}
              <button type="button" className="btn btn-default"
                onClick={this.cancelEditing} title="Отменить">
                <span className="glyphicon glyphicon-remove"></span>
              </button>{" "}
              <button type="button" className="btn btn-danger"
                onClick={this.toggleDelConf} title="Удалить">
                <span className="glyphicon glyphicon-trash"></span>
              </button>
            </div>
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </td>
          {!!user_s && (
            <td>
              <Select
                clearable={false}
                options={orgsOpt}
                value={nData.usrg_org_id}
                onChange={e => this.updateSelect(e,'usrg_org_id')}
                placeholder="Организация"
              />
            </td>
          )}
        </tr>
      );
    }
    else{
      return (
        <tr onClick={this.startEditing}>
          <td>{data.usrg_desc}</td>
          {!!user_s && <td>{orgs[data.usrg_org_id].org_desc}</td>}
        </tr>
      );
    }

  }
}

export default connect(null, { editSets })(SetsUsrgItem);



// WEBPACK FOOTER //
// ./src/components/settings/SetsUsrgItem.js